export const GRID_COLOR = '#bbbbbb'
export const GRID_COLOR_SOFT = '#dddddd'
export const GRID_COLOR_DARK = '#444444'
export const GRID_COLOR_SOFT_DARK = '#222222'
export const GRID_COLOR_DEGRADE = '#bbbbbb'
export const GRID_COLOR_DEGRADE_SOFT = '#dddddd'
export const GRID_COLOR_DEGRADE_DARK = '#444444'
export const GRID_COLOR_DEGRADE_SOFT_DARK = '#222222'
